// extracted by mini-css-extract-plugin
export default {"container":"_C-z","dimension":"aD-z","dimensionLabels":"bD-z"};